import * as React from 'react';

const SvgCircleCheck = (props) => (
  <svg
    data-type="monochrome"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <g fill="currentColor">
      <path d="M16.704 9.27122C17.009 9.59091 16.9971 10.0973 16.6774 10.4023L11.1743 15.6523C10.865 15.9473 10.3784 15.9471 10.0694 15.6518L7.32249 13.0268C7.00306 12.7216 6.99157 12.2152 7.29683 11.8957C7.60208 11.5763 8.10848 11.5648 8.42791 11.8701L10.6225 13.9673L15.573 9.2446C15.8927 8.93962 16.3991 8.95154 16.704 9.27122Z" />
      <path d="M12.0002 3.87344C7.47146 3.87344 3.8002 7.5447 3.8002 12.0734C3.8002 16.6022 7.47146 20.2734 12.0002 20.2734C16.5289 20.2734 20.2002 16.6022 20.2002 12.0734C20.2002 7.5447 16.5289 3.87344 12.0002 3.87344ZM2.2002 12.0734C2.2002 6.66105 6.5878 2.27344 12.0002 2.27344C17.4126 2.27344 21.8002 6.66105 21.8002 12.0734C21.8002 17.4858 17.4126 21.8734 12.0002 21.8734C6.5878 21.8734 2.2002 17.4858 2.2002 12.0734Z" />
    </g>
  </svg>
);

export default SvgCircleCheck;
